import { translateKey } from 'src/locales/translate';
type ErrorMessage = string;

export const EMAIL_ALREADY_IN_USE: ErrorMessage =
  translateKey("hardcoded.psiakosc_adres_e_mail_juz_istnieje_zaloguj_sie");

export const INVALID_EMAIL: ErrorMessage = 
  translateKey("hardcoded.email_musi_byc_prawidlowy");

export const INVALID_LOGIN_CREDENTIALS: ErrorMessage =
  translateKey("hardcoded.psiakosc_nieprawidlowy_adres_e_mail_lub_haslo");

export const WEAK_PASSWORD: ErrorMessage =
  translateKey("hardcoded.haslo_musi_miec_co_najmniej_6_znakow");

export const DEFAULT_ERROR_MESSAGE: ErrorMessage =
  translateKey("hardcoded.cos_poszlo_nie_tak_sprobuj_ponownie_pozniej");
